const jobOrderProfile = '/joborders/profile/:id';

export const EntityRoutes = {
  Login: '/login',

  Home: '/',

  Map: '/map',

  Candidates: '/candidates',
  CandidateProfile: '/candidates/profile/:id',
  CandidateCreate: '/candidates/create',
  CandidateCreateFromResume: '/candidates/create/parse-resume',
  FPCandidateProfile: '/candidate/profile/:id',
  CandidateDataSheet: '/candidates/profile/:id/data-sheet',

  Companies: '/companies',
  CompanyProfile: '/companies/profile/:id',
  CompanyCreate: '/companies/create',
  FPCompanyProfile: '/company/profile/:id',

  JobOrders: '/joborders',
  JobOrderProfile: jobOrderProfile,
  JoborderProfile: jobOrderProfile, // PLEASE do not delete. It's required for the map to work, as the links to profiles are dynamically generated
  JobOrderCreate: '/joborders/create',
  JobOrderEdit: '/joborders/edit/:id',
  FPJobOrderProfile: '/joborder/profile/:id',

  Dashboard: '/dashboard',
  DashboardOverview: '/dashboard/overview',
  DashboardActivity: '/dashboard/activity',
  DashboardPhone: '/dashboard/phone',
  DashboardBulkEmail: '/dashboard/bulkemail',
  DashboardSendout: '/dashboard/sendouts',
  DashboardSendoutLeaders: '/dashboard/leaderboard',
  DashboardFeeAgreements: '/dashboard/feeagreements',
  DashboardToolsUsageReport: '/dashboard/tools-usage-report',

  CommandCenter: '/command-center',
  CommandCenterActivity: '/command-center/activity',
  CommandCenterDailyPerformance: '/command-center/daily-performance',
  CommandCenterDominateSheet: '/command-center/dominate-sheet',
  CommandCenterOverallPerformance: '/command-center/overall-performance',
  CommandCenterOverview: '/command-center/overview',
  CommandCenterOverviewRecruiter: '/command-center/overview/recruiter/:id',
  CommandCenterOverviewTeam: '/command-center/overview/team/:id',
  CommandCenterProductionBoard: '/command-center/production-board',
  CommandCenterFallOffsBoard: '/command-center/fall-offs-board',
  CommandCenterCommissionsBoard: '/command-center/commissions-board',

  DailyPlan: '/daily-plan',

  Contacts: '/contacts',
  ContactProfile: '/contacts/profile/:id',
  FPContactsProfile: '/contact/profile/:id',
  ContactCreate: '/contacts/create',
  FPContactProfile: '/contact/profile/:id',
  HiringAuthorityCreate: '/hiringauthority/create',
  HiringAuthorityProfile: '/hiringauthority/profile/:id',
  FPHiringAuthorityProfile: '/hiringauthority/profile/v2/:id',

  SearchProject: '/searchproject',
  SearchProjects: '/search-projects',
  SearchProjectPreview: '/searchproject/preview/:id',
  SearchProjectsPreview: '/search-projects/preview/:id',
  InventoryProfile: '/candidate/profile/:id',

  // Activity
  BulkEmail: '/bulkemail',
  Email: '/email',
  FeeAgreements: '/feeagreements',

  Calls: '/calls',
  RecruiterProfile: '/roster/profile/:id',
  ResumeSearch: '/resume-search',
  Sendouts: '/sendouts',
  SendoutsFromChannelPartner: '/channel-partner-sendouts',
  SendoutProfile: '/sendouts/profile/:id',
  SendoutCreate: '/sendouts/create',
  Phone: '/phone',
  Roster: '/roster',
  Placements: '/placements',
  Industries: '/industries',
  Teams: '/teams',
  Preview: '/preview',
  Collections: '/collections',
  MessageCenter: '/message-center',

  // For Talent Pool (External)
  TalentPoolApplicantProfile: 'talent-pool/applicants/:id',

  // AI
  Roleplay: '/roleplay'
};
